import { render, staticRenderFns } from "./WabaSupsisAuthIntlPriceEligibilityUpdate.vue?vue&type=template&id=99db2cc2&scoped=true"
import script from "./WabaSupsisAuthIntlPriceEligibilityUpdate.vue?vue&type=script&lang=js"
export * from "./WabaSupsisAuthIntlPriceEligibilityUpdate.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisAuthIntlPriceEligibilityUpdate.vue?vue&type=style&index=0&id=99db2cc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99db2cc2",
  null
  
)

export default component.exports